<template>
    <ul>
        <li v-for="child in root.children" :key="child.id" class="tree-list">
            <catalog :catalog="child"></catalog>
        </li>
    </ul>
</template>
<script>
	import Catalog from './Catalog'

	export default {
		props: {
			root: {
				type: Object,
				default: function () {
					return {}
				}
			},
		},
		components: {
			Catalog
		}
	}
</script>